import { render, staticRenderFns } from "./GetUserForm.vue?vue&type=template&id=54d3bf0d"
import script from "./GetUserForm.vue?vue&type=script&lang=js"
export * from "./GetUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports